module.exports = __webpack_public_path__ + "RohanB-b68d166f.webp";